module.exports = new __parcel__URL__("insights-dark.d8b7ef47.svg").toString();